import { jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import { Divider } from 'primereact/divider';
import { useMemo, Children } from 'react';
import s from './Divided.module.scss.js';

function Divided(_ref) {
  let {
    direction = 'vertical',
    children,
    className,
    dividerClassName
  } = _ref;
  const classes = clsx(s.divided, className, {
    'flex-column': direction === 'horizontal'
  });
  const divider = useMemo(() => jsx(Divider, {
    className: dividerClassName,
    type: "solid",
    layout: direction
  }), [direction, dividerClassName]);
  const content = useMemo(() => {
    if (!children) {
      return children;
    }
    if (typeof children === 'string') {
      return children;
    }
    return Children.toArray(Children.map(children, n => [n, divider])).slice(0, -1);
  }, [children, divider]);
  return jsx("div", {
    className: classes,
    children: content
  });
}

export { Divided };
